export default [
    {
        path: 'veiculo',
        component: () => import(
            '@/views/transporte-paciente/veiculo/Index'
        ),
        redirect: 'veiculo/list',
        children: [
            {
                name: 'transporte-paciente-veiculo-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/veiculo/List'
                ),
            },
            {
                name: 'transporte-paciente-veiculo-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/veiculo/Form'
                ),
            },
            {
                name: 'transporte-paciente-veiculo-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/veiculo/Form'
                ),
            },
        ],
    },
]